import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../context/PermissionContext";

const ProtectedRoute = ({
  element: Element,
  permission,
  layout: Layout,
  ...rest
}) => {
  const user = JSON.parse(localStorage.getItem("userData"));
  const permissions = JSON.parse(localStorage.getItem("userPermissions"));
  // const permpermissionsissions = usePermissions(); // Get permissions
  // Check if the user is authenticated
  if (!user || !user.token) {
    return <Navigate to="/auth/login" />;
  }

  // Check if the user has the required permission
  if (permission && !permissions.includes(permission)) {
    return <Navigate to="/unauthorized" />;
  }

  // Render the layout with the component if authenticated and authorized
  return Layout ? (
    <Layout>
      <Element {...rest} />
    </Layout>
  ) : (
    <Element {...rest} />
  );
};

export default ProtectedRoute;
